import { heroImage, heroStats, seasonBadge, categoryChips } from "@/mocks/site";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-50">
      <div className="pointer-events-none absolute -left-24 top-10 h-72 w-72 rounded-full bg-primary-100/60 blur-3xl" />
      <div className="pointer-events-none absolute right-0 top-40 h-80 w-80 rounded-full bg-accent-100/60 blur-3xl" />

      <div className="relative w-full px-4 pb-16 pt-28 md:px-8 md:pb-24 md:pt-36">
        <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-14">
          <div className="animate-fadeUp">
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3.5 py-1.5 text-xs font-medium text-secondary-900 ring-1 ring-secondary-200">
              <i className="ri-fire-line text-sm text-primary-600" />
              {seasonBadge}
            </span>

            <h1 className="mt-5 text-3xl leading-tight text-foreground-950 md:text-5xl md:leading-[1.15]">
              51动漫新番速览
              <span className="mt-2 block text-primary-600">
                推荐 · 排行 · 番剧表，一站看全
              </span>
            </h1>

            <p className="mt-5 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
              这里整合当季新番推荐、热门动漫排行与详细番剧表，并持续更新动漫资讯。
              你可以按题材标签筛选追番目标，对照每周放送时间安排节奏，
              第一时间了解开播时间与剧情看点，不再错过任何一部重点作品。
            </p>

            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
              <a
                href="#recommend"
                className="inline-flex items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-compass-3-line mr-2" />
                浏览新番推荐
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center justify-center whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                <i className="ri-trophy-line mr-2" />
                查看热门排行
              </a>
            </div>

            <dl className="mt-9 grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-4">
              {heroStats.map((stat) => (
                <div
                  key={stat.label}
                  className="rounded-lg border border-background-200 bg-background-50/80 p-3.5 md:p-4"
                >
                  <div className="flex items-center gap-2 text-primary-600">
                    <i className={`${stat.icon} text-base`} />
                    <dd className="text-lg text-foreground-950 md:text-xl">{stat.value}</dd>
                  </div>
                  <dt className="mt-1 text-xs text-foreground-500">{stat.label}</dt>
                </div>
              ))}
            </dl>
          </div>

          <div className="relative animate-fadeUp">
            <div className="relative mx-auto w-full max-w-md overflow-hidden rounded-2xl border border-background-200 bg-background-100">
              <div className="aspect-[9/11] w-full">
                <img
                  src={heroImage}
                  alt="动漫社团活动室中与好友一同追番的主视觉插画"
                  className="h-full w-full object-top"
                />
              </div>
            </div>

            <div className="absolute -bottom-5 left-2 w-52 rounded-lg border border-background-200 bg-background-50 p-3.5 shadow-none md:left-6">
              <div className="flex items-center gap-2">
                <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className="ri-star-smile-line" />
                </span>
                <div>
                  <p className="text-xs text-foreground-500">本周口碑</p>
                  <p className="text-sm text-foreground-950">治愈系集体上扬</p>
                </div>
              </div>
            </div>

            <div className="absolute -top-3 right-2 hidden rounded-lg border border-background-200 bg-background-50 px-3.5 py-2.5 md:block">
              <p className="text-[11px] text-foreground-500">正在放送</p>
              <p className="text-sm text-primary-700">14 部 · 持续更新</p>
            </div>
          </div>
        </div>

        <div className="mt-12 overflow-hidden rounded-lg border border-background-200 bg-background-100/60 py-3">
          <div className="flex w-max animate-marquee items-center gap-3">
            {[...categoryChips, ...categoryChips].map((chip, index) => (
              <span
                key={`${chip}-${index}`}
                className="flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-50 px-3.5 py-1.5 text-xs text-foreground-600 ring-1 ring-background-200"
              >
                <i className="ri-hashtag text-primary-500" />
                {chip}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}